<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/ecology/partner_banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">为合作伙伴赋能，<br>
          与合作伙伴共同成长</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/ecology/partner01.png" alt="">
          <span class="title">服务支持</span>
          <span class="text">一对一客服，7*12技术服务响应，
            客户成功团队即时在线答疑、远程指导，
            提供定期渠道交流会等一整套服务支持</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/ecology/partner02.png" alt="">
          <span class="title">市场营销</span>
          <span class="text">资源共享互通，
            联合开展市场营销活动、
            技术沙龙分享会、研讨会、行业展会等
          </span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/ecology/partner03.png" alt="">
          <span class="title">技术支持</span>
          <span class="text">
            快速响应客户与合作伙伴需求，
            拥有200人强大的研发团队，
            并持续加大产品研发投入，保持产品领先
          </span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/ecology/partner04.png" alt="">
          <span class="title">生态共赢</span>
          <span class="text">开放、协同、共赢的生态体系，帮助合作伙伴快速融入生态圈，匹配最佳资源，互利共赢，引领合作新模式</span>
        </div>
      </div>
    </div>
    <div class="block02">
      <div class="sk-mobile-title">
        <div class="title">成人达己  互利共赢</div>
      </div>
      <img src="@/assets/Mobile/images/ecology/partner05.png" alt="">
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">携手合作伙伴共同打造生态系统</div>
      </div>
      <img src="@/assets/Mobile/images/ecology/partner06.png" alt="">
    </div>
    <div class="join">
      <div class="sk-mobile-title">
        <div class="title">合作伙伴 期待您的加入</div>
      </div>
      <JoinForm info-sources="生态伙伴" />
    </div>
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import JoinForm from '@/Mobile/Mobilecom/JoinForm'
import IndustrySolution from '@/Mobile/Mobilecom/IndustrySolution'
export default {
  metaInfo: metaInfo.EcoPartner,
  components: {
    JoinForm,
    IndustrySolution
  },
  data() {
    return {

    }
  },
  mounted() {
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  background-color: #fff;
  .content {
    padding: 16px 15px;
    display: flex;
    width: 375px;
    flex-wrap: wrap;
    justify-content: start;
    margin-top: 22px;
    .item {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      line-height: 22px;
      width: 162px;
      height: 153px;
      margin-bottom: 31px;
      justify-content: center;
      align-items: center;
      img {
        width: 71px;
        height: 71px;
      }
      .title {
        margin: 10px 0 5px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
      }
      .text {
        display: inline-block;
        width: 153px;
        height: 47px;
        font-size: 9px;
        font-weight: 400;
        color: #595961;
        line-height: 15px;
        -webkit-text-size-adjust: none;
      }
    }
  }
}
.block02 {
  background-color: #FAFAFA;
  padding-bottom: 20px;
  img {
    display: block;
    width: 341px;
    height: 366px;
    margin: 30px auto 0;
  }
}
.block03 {
  background: #fff;
  padding-bottom: 25px;
  img {
    width: 341px;
    margin-top: 30px;
  }
}

.join {
  width: 375px;
  // height: 520px;
  background: url("~@/assets/Mobile/images/ecology/partner07.png") no-repeat;
  background-size: 100% 100%;
  .title {
    color: #fff;
    padding-bottom: 29px;
  }
}
</style>
